(() => {
  'use strict';

  function initialize(scope) {
    scope.querySelectorAll('[data-hyde-shop-follow-deferred]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const trigger = root.querySelector('[data-hyde-shop-follow-load]');
      const status = root.querySelector('[data-hyde-shop-follow-status]');
      let loading = false;
      let loaded = false;
      let observer;

      async function load() {
        if (loading || loaded) return;
        loading = true;
        const restoreFocus = document.activeElement === trigger;
        trigger.disabled = true;
        trigger.textContent = 'Loading Follow on Shop…';
        status.textContent = 'Loading Follow on Shop';
        root.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('section_id', 'hyde-shop-follow');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Follow section unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const button = doc.querySelector('[data-hyde-shop-follow-content] shop-follow-button');
          const moduleScript = [...doc.querySelectorAll('script[type="module"]')]
            .map((script) => script.textContent)
            .join('\n')
            .match(/import\(["'](https:\/\/cdn\.shopify\.com\/shopifycloud\/shop-js\/[^"']+)["']\)/);
          if (!button || !moduleScript) throw new Error('Follow component unavailable');

          // Use Shopify's current generated module, without evaluating response scripts.
          await import(moduleScript[1]);
          const nativeButton = document.importNode(button, true);
          trigger.replaceWith(nativeButton);
          status.textContent = 'Follow on Shop is ready';
          loaded = true;
          if (observer) observer.disconnect();
          if (restoreFocus) {
            nativeButton.setAttribute('tabindex', '-1');
            nativeButton.focus();
          }
        } catch (_error) {
          trigger.disabled = false;
          trigger.textContent = 'Retry Follow on Shop';
          status.textContent = 'Follow on Shop could not load. Select retry to try again.';
        } finally {
          loading = false;
          root.removeAttribute('aria-busy');
        }
      }

      trigger.addEventListener('click', load);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) load();
        }, { rootMargin: '600px 0px' });
        observer.observe(root);
      }
    });
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
